import React from 'react';
import { ApolloProvider, ApolloConsumer } from '@apollo/react-hooks';
import TastingKitPromoComponent from './TastingKitPromoComponent';
import { client } from '../../../../../monorepo/apollo/client';

interface ImageTileProps {
  alt?: string;
  mobile: {
    src: string;
    height: number;
    width: number;
  };
  tablet: {
    src: string;
    height: number;
    width: number;
  };
  desktop: {
    src: string;
    height: number;
    width: number;
  };
}

interface TastingKitPromoProps {
  user: any;
  config: {
    buttonLink?: string;
    buttonTwoLink?: string | null;
    images: ImageTileProps;
    imageSide: string;
    isTextBoxOverlay?: true;
    textAlign: string;
    headerTextAlign?: string;
    textWrapperImage?: {
      alt: string;
      src: string;
      height: number;
      width: number;
    };
    buttonOverlayLink?: string;
  };
}

const TastingKitPromo = ({ user, config }: TastingKitPromoProps) => {
  return (
    <>
      <ApolloProvider client={client}>
        <ApolloConsumer>
          {apolloClient => (
            <TastingKitPromoComponent
              user={user}
              apolloClient={apolloClient}
              config={config}
            />
          )}
        </ApolloConsumer>
      </ApolloProvider>
    </>
  );
};

export default TastingKitPromo;
